export const getUrlQueries = () => {
  const params = (window.location.href.split("?")[1] || "").split("&")

  const result = {} as Record<string, any>
  for (const param of params) {
    if (param.includes("=")) {
      const [key, value] = param.split("=")
      result[key] = decodeURIComponent(value)
    }
  }

  return result
}
